import PropTypes from "prop-types";
import React, { createContext, useContext, useMemo } from "react";

const SimulationContext = createContext();
const card = {
  number: "6051460012312312312",
  status: "Active",
  balance: 3264,
  currency: "EUR",
  expirationDate: new Date(2064, 8, 4).toString(),
  product: { name: "Test Card" },
  transactions: [
    {
      date: new Date(1111, 2, 9),
      command: "activate",
      amount: 25000,
      currency: "EUR",
      retailer: {
        name: "123TCS",
        city: "Breukelen",
      },
    },
    {
      date: new Date(1234, 3, 9),
      command: "subtract",
      amount: 1000,
      currency: "EUR",
      retailer: {
        name: "123TCS",
        city: "Breukelen",
      },
    },
    {
      date: new Date(5678, 4, 9),
      command: "retire",
      amount: 0,
      currency: "EUR",
      retailer: {
        name: "123TCS",
        city: "Breukelen",
      },
    },
    {
      date: new Date(9999, 5, 9),
      command: "add",
      amount: 1000,
      currency: "EUR",
      retailer: {
        name: "123TCS",
        city: "Breukelen",
      },
    },
    {
      date: new Date(2024, 6, 9),
      command: "suspend",
      amount: 0,
      currency: "EUR",
      retailer: {
        name: "123TCS",
        city: "Breukelen",
      },
    },
    {
      date: new Date(2024, 7, 9),
      command: "unsuspend",
      amount: 1000,
      currency: "EUR",
      retailer: {
        name: "123TCS",
        city: "Breukelen",
      },
    },
    {
      date: new Date(2025, 8, 9),
      command: "cancel",
      amount: 0,
      currency: "EUR",
      retailer: {
        name: "123TCS",
        city: "Breukelen",
      },
    },
    {
      date: new Date(2026, 11, 9),
      command: "unknown",
      amount: 1000,
      currency: "EUR",
      retailer: {
        name: "123TCS",
        city: "Breukelen",
      },
    },
  ],
};

export function SimulationProvider({
  simulateEditorSettings,
  showTooltips,
  children,
}) {
  // Memos
  const value = useMemo(
    () => ({ simulateEditorSettings, showTooltips, card }),
    [simulateEditorSettings, showTooltips, card],
  );

  // Render
  return (
    <SimulationContext.Provider value={value}>
      {children}
    </SimulationContext.Provider>
  );
}

SimulationProvider.propTypes = {
  simulateEditorSettings: PropTypes.bool,
  showTooltips: PropTypes.bool,
  children: PropTypes.element,
};

SimulationProvider.defaultProps = {
  simulateEditorSettings: false,
  showTooltips: false,
  children: null,
};

export const useSimulation = () => {
  const context = useContext(SimulationContext);

  if (context === undefined) {
    throw new Error("useSimulation must be used within a SimulationProvider");
  }
  return context;
};
